/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AssignAdminProfileRequest} from '../models/AssignAdminProfileRequest';
import type {Error} from '../models/Error';

export interface AssignAdminProfile$Request {
    adminId: number;
    profileId: number;
    assignAdminProfileRequest?: AssignAdminProfileRequest;
}

export interface AssignAdminProfile$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const assignAdminProfileRequest = createAction<PayloadData<void, AssignAdminProfile$Request>>('ASSIGN_ADMIN_PROFILE__ASSIGN_ADMIN_PROFILE__REQUEST');
export const assignAdminProfileSuccess = createAction<PayloadData<void, AssignAdminProfile$Request>>('ASSIGN_ADMIN_PROFILE__ASSIGN_ADMIN_PROFILE__SUCCESS');
export const assignAdminProfileFailure = createAction<PayloadData<Error, AssignAdminProfile$Request, true>>('ASSIGN_ADMIN_PROFILE__ASSIGN_ADMIN_PROFILE__FAILURE');

export const assignAdminProfileActions = [
    assignAdminProfileRequest,
    assignAdminProfileSuccess,
    assignAdminProfileFailure
] as const;

/**
 * @param {number} meta.adminId
 * @param {number} meta.profileId
 * @param {AssignAdminProfileRequest} [meta.assignAdminProfileRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const assignAdminProfile = (meta: AssignAdminProfile$Request, config?: AssignAdminProfile$Config) => {
    return {
        CALL_API: {
            types: assignAdminProfileActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/admins/${meta.adminId}/profiles/${meta.profileId}`,
            TRANSPORT_REQUEST_BODY: meta.assignAdminProfileRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

